export default __webpack_public_path__ + "7a2dcae25524daba0f2f1485ce5c07e3.jpg";